import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { faRobot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Snackbar } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import VoxelButton from '../../../../../components/voxel/Buttons/VoxelButton';
import VoxelText from '../../../../../components/voxel/Text/VoxelText';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import { QueuedItemStatus } from '../../../../../graphql/projects/models/QueuedItemStatus';
import { copyToClipboard } from '../../../../../logic/otherUtilities/copyTextToClipboard';

export interface ContentTaskChatGPTProps {
  contentTask: ContentTaskGq;
}

export const ContentTaskChatGPT: React.FC<ContentTaskChatGPTProps> = ({ contentTask }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState<string>();

  // Copy function
  const handleCopy = useCallback(() => {
    try {
      // Prepare copy text
      const copyText = contentTask.chatGptResult;

      // Copy result
      const copyResult = copyToClipboard(copyText);

      // Show feedback
      if (copyResult) {
        setShowSnackbar(true);
      } else {
        setErrorSnackbarMessage('Copy not supported by browser - try Chrome instead');
      }
    } catch {
      // Show eventual error
      setErrorSnackbarMessage('Copy error - something went wrong');
    }
  }, [contentTask]);

  return (
    <div className="flex flex-col gap-3 w-96">
      <div className="flex flex-row items-center flex-nowrap gap-3 ">
        <FontAwesomeIcon
          size="lg"
          className={
            contentTask.chatGptStatus === QueuedItemStatus.SUCCEEDED
              ? 'text-success-500'
              : contentTask.chatGptStatus === QueuedItemStatus.PROCESSING
                ? 'text-warning-500'
                : ''
          }
          icon={faRobot}
        />
        <VoxelText variant="title2">ChatGPT content</VoxelText>
        {contentTask.chatGptStatus === QueuedItemStatus.PROCESSING && (
          <CircularProgress size={'small'} />
        )}
      </div>
      <div className="max-h-[600px] overflow-y-auto select-text">
        <VoxelText className="whitespace-pre-wrap">{contentTask.chatGptResult}</VoxelText>
      </div>
      <div className="flex flex-row justify-end mt-2">
        <VoxelButton
          size="sm"
          title="Copy"
          tooltip="Copy to clip board"
          endIcon={<FontAwesomeIcon icon={faCopy} />}
          onClick={() => handleCopy()}
        />
      </div>
      <Snackbar
        message={'Copied to clipboard'}
        open={showSnackbar}
        onClick={() => setShowSnackbar(false)}
      />
      <Snackbar
        open={!!errorSnackbarMessage?.length}
        onClick={() => setErrorSnackbarMessage(undefined)}
        message={errorSnackbarMessage}
      />
    </div>
  );
};

export default ContentTaskChatGPT;
